import {
  EnhancedWithPersonalChatViewContract,
  EnhancedWithPersonalChatProps,
  EnhancedWithPersonalChatState
} from './types'
import {Sync} from '../../client/sync'
import {SyncListeners} from '../../client/sync-listeners'
import {createSyncedEnhancerContainer} from '../synced-enhancer-container'
import {PersonalChatProxy} from '../../extensions/proxies/personal-chat-proxy'
import {DirectMessages} from '../../client/direct-messages'
import {User} from 'yougile-model'

export const createEnhancedWithSyncedPersonalChat = <
  ViewProps extends EnhancedWithPersonalChatViewContract
>(
  View: React.ComponentType<ViewProps>
) => {
  const subscribe = (
    update: () => void,
    {chatId}: EnhancedWithPersonalChatProps<ViewProps>
  ) => {
    SyncListeners.addListener(update, Sync.profileId, chatId)
  }

  const unsubscribe = (update: () => void) => {
    SyncListeners.removeListener(update)
  }

  const stateFromProps = ({
    chatId
  }: EnhancedWithPersonalChatProps<ViewProps>) => {
    const companionId = Sync.getOtherUserIds().find(uid => {
      const hub = DirectMessages.getChatIfExists(uid)

      return hub && hub.id === chatId
    })
    const profile = Sync.getProfile()
    const companion = profile.get(companionId) as User
    return companion && PersonalChatProxy.createForCurrentUser(companion)
  }

  type Prop = keyof EnhancedWithPersonalChatProps<ViewProps>

  const resubscribeOnPropChange = (): Prop[] => ['chatId']

  return createSyncedEnhancerContainer<
    EnhancedWithPersonalChatProps<ViewProps>,
    EnhancedWithPersonalChatState,
    EnhancedWithPersonalChatViewContract,
    ViewProps
  >(View, subscribe, unsubscribe, stateFromProps, resubscribeOnPropChange)
}
